/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_options.js                                                                         */
/**********************************************************************************************************************/
/* Controller.Options */

/**
 * @class this.Controller.Options
 */
HafasWebapp.prototype.Controller.Options = {

  _getAppContext: function(params) {
    var currentContext = this.appContext;
    if(params && params.hasOwnProperty('context')) {
      currentContext = params.context;
    }
    return currentContext;
  },

  /**
   * get specific options model by name
   *
   * @method module.get
   * @params name
   * @return {object} the existing model
   */
  getModelByName: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var model = this.Controller[context].options.getModelByName(params.name);
    return model;
  },

  /**
   * get specific options model by name
   *
   * @method module.get
   * @params name
   * @return {object} the existing model
   */
  getModelById: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var model = this.Controller[context].options.getModelById(params.id);
    return model;
  },

  getOptionTexts: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var text = this.Controller[context].options.getOptionTexts();
    return text;
  },

  setOptionValue: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    this.Controller[context].options.setRandomParameter(params.id, 'value', params.value);
  },

  setOptionParameter: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    this.Controller[context].options.setRandomParameter(params.id, params.parameter, params.value);
  },

  setProducts: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    this.Controller[context].options.setOptionModel(params);
    Hafas.ps.pub('/options/gui/render');
  },

  // currently missing: function getProductClass() in stboard /mroe
  resetProducts: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var parentContainer = params.element.parentNode;
    // TEMP (default checked status for products has to be defined in the data model)
    this.Controller[context].instance.setProductClass(8191, true);
    var model = {products: this.Controller.Common.productSelection( this.Controller[context].instance.getProductClass(), context )};
    Hafas.Modules.Render.render({target: parentContainer, template: 'Common_Tab1', model: model});
  },

  setProductSelection: function(context, params, enable) {
    var productList = Hafas.Util.products.getForContext(context);
    for (var i = 0; i < productList.length; i++) {
      var id = "HFS_" + productList[i].id;
      this.Controller[context].options.setRandomParameter(id, 'value', enable);
    }
    Hafas.ps.pub('/options/gui/render', [{groupId: params.groupId}]);
  },

  setAllProducts: function (params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    Hafas.bind(this.Controller.Options.setProductSelection, this)(context, params, true);

    this.Controller[context].options.announceCurrentProducts();
  },
  setRegioProducts: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    Hafas.bind(this.Controller.Options.setProductSelection, this)(context, {groupId: params.groupId}, true);
    this.Controller[context].options.setRandomParameter("HFS_ICE", 'value', false);
    this.Controller[context].options.setRandomParameter("HFS_IC", 'value', false);
    this.Controller[context].options.setRandomParameter("HFS_IR", 'value', false);
    Hafas.ps.pub('/options/gui/render', [{groupId: params.groupId}]);

    this.Controller[context].options.announceCurrentProducts();
  },

  initOptions: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var selectIds = this.Controller[context].options.getModelsByType("select");
    for(var i = 0; i < selectIds.length; i++) {
      var callback = function(params) {
        Hafas.ps.pub('/options/set/value',[{id: params.trigger.id, value: params.value}]);
      };
      Hafas.Core.newType('HafasSelectBox', {holder: selectIds[i].id + '_Holder', callback: callback}).initiate();
    }
    Hafas.ps.pub('/' + context + '/options/init', [this.Controller[context].options.get()]);
  },

  resetOptions: function(announceIt) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)({});
    this.Controller[context].options.reset({app: context, announceIt: announceIt});
    Hafas.ps.pub('/options/gui/render');
    Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
  },

  haveOptionsChanged: function(params) {
    var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
    var boolval = this.Controller[context].options.haveOptionsChanged();
    return boolval;
  },

  GUI: {

    renderOptions: function(params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)({});
      var parentContainer = Hafas("#HFS_CustomerOptionsWrap");
      var tabcontent = this.Controller[context].options.get();
      var model = {
        name: Hafas.Modules.i18n.get('common.label.t_N_Options'),
        tpl: 'Common_AtomTplOptions',
        tabcontent: tabcontent
      };
      Hafas.Modules.Render.render({target: parentContainer, template: 'Common_AtomTplOptions', model: model});
      Hafas.ps.pub('/options/init');
      // via-felder nach dem Zur�cksetzen neu initiieren
      if(context == "TP") {
        Hafas.ps.pub('/TP/options/init', [tabcontent]);
      }
      if(context == "SQ") {
        Hafas.ps.pub('/SQ/options/init', [tabcontent]);
      }
      Hafas.ps.pub('/GUI/common/fixedElements/setHeights', [{me: this}]);
      Hafas.ps.pub('/options/setChangedOptionsInputForm');
      if(params && params.groupId) {
        var screen = this.Controller[context].options.getModelById(params.groupId).screen;
        if(screen == "drilldown") {
          var options = this.Controller[context].options.get();
          for(var i = 0; i < options.questionList.length; i++) {
            var optionElement = null;
            if(options.questionList[i].id == params.groupId) {

            }
            if(options.questionList[i].id != params.groupId) {
              optionElement = Hafas("#" + options.questionList[i].id + "_Container");
            } else {
              optionElement = Hafas("#" + options.questionList[i].id + "_Tab");
            }
            Hafas.Util.gui.setVisibility(optionElement, false);
          }
        }
      }
    },

    /**
     * Function to fill the changed options container on the application's input form
     * with a changed options text
     *
     * @method module.setChangedOptionsInputForm
     * @params {object} params | params.parentContainer: the container for changed options |
     *                           params.template: the template to use for the changed options text
     */
    setChangedOptionsInputForm: function(params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      if(typeof this.Controller[context].options == 'undefined'){
        return;
      }
      var model = this.Controller[context].options.getOptionTexts();
      var parentContainer = Hafas("[data-additional-info='selected_options_" + context + "']");
      var detailsContainer = Hafas("[data-additional-info='selected_products_" + context + "']");
      if((typeof params != "undefined") && (params.hasOwnProperty('parentContainer'))) {
        parentContainer = params.parentContainer;
      }
      if((parentContainer != null) && (model.infoText != "")) {
        // var template = 'Common_AtomTplButton';
        var template = 'Common_AtomTplOptionInfo';
        var file = 'common.options.html';
        // Hafas.Modules.Atoms.append('common.options.changedOptionInfo', {model: model});
        Hafas.Modules.Render.render(
            {file: file,
              target: parentContainer,
              template: template,
              model: model}, function() {
              Hafas.ps.pub('/app/events/resize');
            });
      } else if((parentContainer != null) && (model.infoText == "")) {
        parentContainer.innerHTML = "";
      }
      if(Hafas('#HFS_OptionsButton' + context)) {
        var contextBtn = Hafas('#HFS_OptionsButton' + context);
        if(model.infoText != "") {
          contextBtn.addClassName('js_optionsChanged');
          contextBtn.setAttribute("aria-checked", "true");
        } else {
          contextBtn.removeClassName('js_optionsChanged');
          contextBtn.setAttribute("aria-checked", "false");
        }
      }
      if((detailsContainer != null) && (model.prodText != "")) {
        // Rendering product changes
        if (model.prodText != "") {
          Hafas.Modules.Render.render({
            file: 'common.options.html',
            target: detailsContainer,
            template: 'Common_AtomTplOptionInfoProducts',
            model: model
          }, function() {
            Hafas.ps.pub('/app/events/resize');
          });
        }
      } else if((detailsContainer != null) && (model.prodText == "")) {
        detailsContainer.innerHTML = "";
      }
    },

    toggleOptionDialog: function(params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      if (Hafas.Modules.History)
        Hafas.Modules.History.addOrUpdateData(context, params.view, {});
      var $coreForm = Hafas('[data-render-element="fieldset_wrapper"]', false);
      var $favoritesWrap = Hafas('[data-render-element="favorites_container"]', false);
      // Neue Toggle-Funktion mit ARIA-Attributen (Barrierefreiheit)
      // Gibt neuen status zurück
      params.surrounding = true;
      params.blockFocus = true;
      var _visibleOptions = Hafas.ps.pub('/GUI/common/atomToggleContainer', [params]);

      // Haben sich die Default-Optionen geändert? - Dann ändere checked und somit auch das Icon
      var trigger = null;
      if(!params.trigger && params.target) {
        trigger = Hafas("#" + params.target).getAttribute('aria-labelledby');
      } else {
        trigger = params.trigger;
      }
      if(trigger != null) {
        if (this.Controller[context].options.haveOptionsChanged({context: context})) {
          trigger.setAttribute('aria-checked', true);
        }
        else {
          trigger.setAttribute('aria-checked', false);
        }
      }

      Hafas.Util.gui.setVisibility($favoritesWrap, !_visibleOptions);

      // Im Falle, dass der Unified Planner angeschaltet ist: auch den Ergebniscontainer ausblenden
      if(context == "TP") {
        var $resultContainer = Hafas("#TP_ResultOverview");
        if($resultContainer && Hafas.Config.TP.unifiedPlanner.show) {
          Hafas.Util.gui.setVisibility($resultContainer, !_visibleOptions);
        }
      }

      if ((typeof _visibleOptions != 'undefined' && _visibleOptions === true)) {
        switch (context) {
          case 'TP':
            Hafas.ps.pub('/tracking/event/journey-planner-options', [ { typ: 'event', key: 'journey-planner-options' } ]);
        }
      }

      // Barrierefreiheit: Webapp beginnt erst mit Suche, obwohl eigentlich Optionen zu sehen sind.
      // TODO: Gibt es einen Parameter der beides parallel anzeigt?
      Hafas.Util.gui.setVisibility($coreForm, !_visibleOptions);
      Hafas.ps.pub('/app/events/resize');
    },

    toggleOptionGroup: function(params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      var panelModel = this.Controller[context].options.getModelById(params.groupId);
      var screen = panelModel.screen;
        // Hafas.ps.pub('/GUI/options/optionGroup/toggle', [{trigger: params.trigger, target: params.target, screen: params.screen}]);
        if (Hafas.Modules.History && (screen == "drilldown"))
          Hafas.Modules.History.addOrUpdateData(context, params.view, params);

        var display = "block";
        if(panelModel.display == "block") {
          display = "none";
        }
        this.Controller[context].options.setRandomParameter(panelModel.id, 'display', display);

        if(screen == "drilldown") {
          params.blockFocus = true;
          /** Inaktive Optionen müssen ganz ausgeblendet werden, damit sie nicht hinter/unter dem aktiven Detail-Container zu sehen sind **/
          // params.surrounding = true;
          var showOptions = false;
          if(display == "none") {
            showOptions = true;
          }
          var options = this.Controller[context].options.get();
          for(var i = 0; i < options.questionList.length; i++) {
            var optionElement = null;
            if(options.questionList[i].id != panelModel.id) {
              optionElement = Hafas("#" + options.questionList[i].id + "_Container");
            } else {
              optionElement = Hafas("#" + options.questionList[i].id + "_Tab");
            }
            Hafas.Util.gui.setVisibility(optionElement, showOptions);
          }
        }
        Hafas.ps.pub('/GUI/common/atomToggleContainer', [params]);

        this.Controller[context].options.getModelByName(params.target);
        Hafas.ps.pub('/options/setChangedOptionsInputForm', [{}]);
    },
    // Bei Kontextwechsel müssen Optionen-Gruppen (zB. Verkehrsmittelauswahl) ggf. datenseitig auf Standard-Zustand zurückgesetzt werden
    closeAllOptionGroups: function(params) {
      var context = Hafas.bind(this.Controller.Options._getAppContext, this)(params);
      var optiongroupIds = this.Controller[context].options.getModelsByType("optiongroup");
      for(var i = 0; i < optiongroupIds.length; i++) {
          var display = this.Controller[context].options.getStandardParameter("display", optiongroupIds[i].id);
          this.Controller[context].options.setRandomParameter(optiongroupIds[i].id, 'display', display);
      }
    },

    toggleViaOptions: function(params) {
      if(params.id && params.hasOwnProperty('visibility')) {
        var activatedFields = Hafas("#" + params.id + "_Container [data-via-field='toggle']", true);
        var visibility = params.visibility;
        for(var i = 0; i < activatedFields.length; i++) {
          Hafas.Util.gui.setVisibility(activatedFields[i], visibility);
        }
      }
      // console.log("this.Controller.Options", this.Controller.Options);
      this.Controller.Options.GUI.toggleDeleteButton(params);
    },

    toggleDeleteButton: function(params) {
      var deleteButtons = Hafas("#" + params.id + "_Container [data-field='delete']", true);
      var visibility = params.visibility;
      for(var i = 0; i < deleteButtons.length; i++) {
        Hafas.Util.gui.setVisibility(deleteButtons[i], visibility);
      }
    }
  }

};
